export const environment = {
  production: true,
  favoriotPaymentUrl: 'https://payment.favoriot.com/favoriot/',
  favoriotPaymentUrl2: 'https://payment.favoriot.com/',
  apiUrl: 'https://apiv2.favoriot.com/v2/',
  apiUrlWOVersion: 'https://apiv2.favoriot.com/',
  summaryDataUrl: 'https://apiv2.favoriot.com/favoriotadmin/',
};
